import React from 'react';

function Contact() {
  return (
    <div className="page-container">
      <h1>Contact Us</h1>
      <p>Email: info@indodeftech.com</p>
      <p>Phone:  +91 99903 30700 </p>

       <h4>Our Offices</h4>
          <div className="office">
            <h5>Noida</h5>
            <p>E-53, 3rd Floor, Sector 63<br />Noida, Uttar Pradesh 201301</p>
          </div>
          <div className="office">
            <h5>Gurugram</h5>
            <p>AF-005-007, 1st Floor, Conscient One<br />Sector 109, Gurugram, Haryana 122006</p>
          </div>
    </div>
  );
}

export default Contact;
